import { TTypeOfSchedule, TTypeOfReport } from 'types';
import { IEmails, TTypeOfModalWindow, IDataForSubmit } from './reportsState/reportsContext';

export enum ReportsActionsTypes {
	SET_HAS_BAN_ON_CHANGES = 'SET_HAS_BAN_ON_CHANGES',
	SET_ALL_DATA = 'SET_ALL_DATA',
	SET_ID_REPORT_TYPE = 'SET_ID_REPORT_TYPE',
	SET_IDS_SCHEDULE_TYPES = 'SET_IDS_SCHEDULE_TYPES',
	CHANGE_EMAILS = 'CHANGE_EMAILS',
	CHANGE_COPY_EMAILS = 'CHANGE_COPY_EMAILS',
	TOGGLE_SENDING_REPORT_AFTER_SHIFT_CLOSING = 'TOGGLE_SENDING_REPORT_AFTER_SHIFT_CLOSING',
	SET_DATA_FOR_SUBMIT = 'SET_DATA_FOR_SUBMIT',
	CHANGE_TYPE_OF_MODAL_WINDOW = 'CHANGE_TYPE_OF_MODAL_WINDOW',
}

interface ISetHasBanOnChanges {
	type: ReportsActionsTypes.SET_HAS_BAN_ON_CHANGES;
	payload: {
		hasBanOnChanges: boolean;
	};
}

interface ISetAllData {
	type: ReportsActionsTypes.SET_ALL_DATA;
	payload: {
		restaurantId: string;
		id: string;
		IDReportType: null | TTypeOfReport;
		IDsScheduleTypes: TTypeOfSchedule[];
		emails: IEmails[];
		copyEmails: IEmails[];
		sendingReportAfterShiftClosing: boolean;
	};
}

interface ISetIDReportType {
	type: ReportsActionsTypes.SET_ID_REPORT_TYPE;
	payload: {
		IDReportType: null | TTypeOfReport;
		sendingReportAfterShiftClosing: boolean;
		IDsScheduleTypes: TTypeOfSchedule[];
	};
}

interface ISetIDsScheduleTypes {
	type: ReportsActionsTypes.SET_IDS_SCHEDULE_TYPES;
	payload: {
		IDsScheduleTypes: TTypeOfSchedule[];
	};
}

interface IChangeEmails {
	type: ReportsActionsTypes.CHANGE_EMAILS;
	payload: {
		emails: IEmails[];
	};
}

interface IChangeCopyEmails {
	type: ReportsActionsTypes.CHANGE_COPY_EMAILS;
	payload: {
		copyEmails: IEmails[];
	};
}

interface IToggleSendingReportAfterShiftClosing {
	type: ReportsActionsTypes.TOGGLE_SENDING_REPORT_AFTER_SHIFT_CLOSING;
}

interface ISetDataForSubmit {
	type: ReportsActionsTypes.SET_DATA_FOR_SUBMIT;
	payload: {
		dataForSubmit: IDataForSubmit | null;
	};
}

interface IChangeTypeOfModalWindow {
	type: ReportsActionsTypes.CHANGE_TYPE_OF_MODAL_WINDOW;
	payload: {
		typeOfModalWindow: TTypeOfModalWindow;
	};
}

export type TReportsAction =
	| ISetHasBanOnChanges
	| ISetAllData
	| ISetIDReportType
	| ISetIDsScheduleTypes
	| IChangeEmails
	| IChangeCopyEmails
	| IToggleSendingReportAfterShiftClosing
	| ISetDataForSubmit
	| IChangeTypeOfModalWindow;
